<template>
    <article>
        <p>
            Coroot uses Prometheus to store metrics.
            To integrate Coroot with Prometheus, go to the project settings (<v-icon small>mdi-cog</v-icon>),
            click on <b>Prometheus</b>, and define the Prometheus address and credentials as shown in the following example:
        </p>

        <v-card max-width="1200">
            <v-img eager src="/static/img/docs/coroot/prometheus_configuration.png" />
        </v-card>

        <p>
            Coroot is compatible with any Prometheus-compatible time series
            databases such as VictoriaMetrics, Thanos, or Grafana Mimir.
        </p>

        <h2>Metric cache</h2>

        <p>
            For faster access, Coroot maintains its own on-disk metric cache, continuously retrieving metrics from Prometheus.
            As a result, Coroot treats the time series database as a source for updating its cache.
            This allows you to configure Prometheus with a shorter retention period, such as a few hours.
        </p>

        <p>
            The retention of Coroot's metric cache can be configured using the <var>--cache-ttl</var> CLI argument of the <var>CACHE_TTL</var>
            environment variable. Check the <router-link :to="{name: 'docs', params: {chapter: 'coroot', group: 'configuration', item: 'cli-arguments'}}">CLI arguments</router-link> section for more details.
        </p>
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
